// 定义配置数组
const patterns = [
  { regex: /\d{4}年\d{1,2}月\d{1,2}日/, format: { t: 'd', fa: 'yyyy"年"M"月"d"日"' } }, //1982年11月12日
  { regex: /^\d{4}\/\d{2}\/\d{2}$/, format: { t: 'd', fa: 'yyyy/MM/dd' } }, // 2012/10/13
  { regex: /^\d{4}年(0[1-9]|1[0-2])月$/, format: { t: 'd', fa: 'Y.m.z' } }, //2012年10月
  { regex: /^\d{1,2}月\d{1,2}日$/, format: { t: 'd', fa: 'M"月"d"日"' } }, // 10月15日
  { regex: /^\d{4}-\d{2}-\d{2}$/, format: { t: 'd', fa: 'yyyy-MM-dd' } }, // 2012-10-16
  { regex: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$/, format: { t: 'd', fa: 'h:mm:ss' } }, //6:05:02
  { regex: /^\d{1,2}:\d{2}$/, format: { t: 'd', fa: 'h:mm' } }, // 4:23
  { regex: /^(上午|下午)\d{1,2}时\d{1,2}分\d{1,2}秒$/, format: { t: 'd', fa: '上午/下午 h:mm:ss' } }, // 上午6:23:45
  { regex: /^(上午|下午)\d{1,2}时\d{1,2}分$/, format: { t: 'd', fa: '上午/下午 h:mm' } } // 上午6:23
]

// 通过date字符串拿到它对应在luckySheet的类型
function getFmt(str) {
  for (const pattern of patterns) {
    if (pattern.regex.test(str)) {
      return pattern.format
    }
  }
  return { fa: 'General', t: 'n' } // 默认格式
}

export { getFmt }
